import { BaseService } from './BaseService';

export interface AgentLog {
    id: string;
    chatId: string;
    requestId: string;
    agentName: string;
    agentLogType: string;
    content: string;
    timestamp: string;
    tokenUsage: string;
    duration: string;
}

export class AgentLogService extends BaseService {
    async getAgentLogs(endpoint: string, accessToken?: string): Promise<AgentLog[] | null> {
        return this.getResponseAsync(
            {
                commandPath: endpoint,
                method: 'GET',
            },
            accessToken,
        );
    }
}
